export const HOME_PATH = "/frontpage";
export const PROFILE_PATH = "/profile";
export const TIMESHEETS_OVERVIEW_PATH = "/timesheets";
export const TIMESHEET_PATH = "/timesheet";
export const MESSAGES_PATH = "/messages";
export const DOCUMENTS_PATH = "/profile/documents";
export const CV_PATH = "/profile/cv";
export const SETTINGS_PATH = "/settings";
export const LOGIN_PATH = "/login";
export const WORKSCHEDULE_PATH = "/workschedule";
export const JOBS_PATH = "/jobs";
